import injectIntl from "../../../../../common/helpers/injectIntl";
import { connect } from "react-redux";
import { IStateTree } from "../../../../store/interfaces";
import { IUser, SolfaAudioType } from "../../../../store/user/models";

import lazyComponent from "./lazy";

const mapStateToProps = ({ user }: IStateTree) => ({
    solfaAudio: (user as IUser).solfaAudio || SolfaAudioType.Solfa,
    solfaKam: (user as IUser).solfaKam || false,
    solfaShort: (user as IUser).solfaShort || false,
});

export default connect(mapStateToProps)(injectIntl(lazyComponent));
